// src/pages/AiAnalysisPage.tsx
import React, { useState } from "react";
import { apiPostJson } from "../utils/apiClient";

export default function AiAnalysisPage() {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    const runAnalysis = async () => {
        setLoading(true);
        setResult(null);
        setError(null);

        try {
            const res = await apiPostJson<{
                ok: boolean;
                analysis?: string;
            }>("/api/ai/analyze", {
                type: "monthly_pl",
            });

            setResult(res.analysis ?? "分析結果なし");
        } catch (e: any) {
            console.error(e);
            setError(e.message ?? "AI分析に失敗しました");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-6">
            <h1 className="text-xl font-semibold">AI分析</h1>

            <button
                onClick={runAnalysis}
                disabled={loading}
                className="rounded-xl bg-blue-600 px-4 py-2 text-white text-sm hover:bg-blue-700 disabled:opacity-50"
            >
                {loading ? "分析中..." : "月次損益をAI分析"}
            </button>

            {error && (
                <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
                    {error}
                </div>
            )}

            {result && (
                <div className="rounded-xl border bg-white p-4 text-sm whitespace-pre-wrap">
                    {result}
                </div>
            )}
        </div>
    );
}
